import React, { ReactNode } from 'react';
import { get } from 'lodash';

import {
  Box,
  Container,
  ContainerProps,
  IconButton,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
} from '@mui/material';

import { links } from '../../paths';

import { Menu } from '../../atoms/icons/menu';
import { Settings } from '../../atoms/icons/settings';
import { Notification } from '../../atoms/icons/notification';

import { useSelector } from '../../store/utils';

import { LinkComponent } from '../../atoms/link-component';
import { To } from 'react-router-dom';
import { ArrowLeft } from '../../atoms/icons/arrow-left';

export type HeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  goBack?: To | -1;
  desktopNavToggle: () => void;
} & Omit<ContainerProps, 'title'>;

export const HeaderSubpage = ({
  title,
  goBack,
  desktopNavToggle,
  ...props
}: HeaderProps) => {
  const premium = useSelector(({ variables }) => get(variables, 'PREMIUM'));

  const md = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <Container
      {...props}
      component="header"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        mb: 4,
        ...(props.sx || {}),
      }}
    >
      <IconButton
        to={goBack as any}
        component={LinkComponent}
        sx={{ mr: 2, '& .MuiSvgIcon-root': { fontSize: 20 } }}
      >
        <ArrowLeft />
      </IconButton>

      {/* title */}
      <Typography variant="h1">{title}</Typography>

      {/* settings */}
      <Box
        sx={{
          ml: 'auto',
          '& .MuiSvgIcon-root': { fontSize: 20 },
        }}
      >
        {premium && (
          <IconButton to={links.appMessages} component={LinkComponent}>
            <Notification />
          </IconButton>
        )}

        {md ? (
          <IconButton onClick={desktopNavToggle} className="desktop-nav-open">
            <Menu />
          </IconButton>
        ) : (
          <IconButton to={links.settings || '#'} component={LinkComponent}>
            <Settings />
          </IconButton>
        )}
      </Box>
    </Container>
  );
};
